var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonRemove = function SvgPersonRemove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 17h-4M12.47 3.023A3.492 3.492 0 1 1 7.53 7.96a3.492 3.492 0 0 1 4.94-4.938Zm1.893 9.773c-1.299-.519-2.823-.805-4.363-.805-4.048 0-8 1.967-8 4.992v1a1 1 0 0 0 1 1h9.413c-.562-1.297-.96-4.35 1.95-6.187ZM17 22a5 5 0 0 1-5-5c0-2.704 2.3-5.003 5.004-5A5 5 0 0 1 17 22Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonRemove);
export default ForwardRef;